import cart from "../../api/cart";

export default {
  namespaced: true,
  state: {
    items: [],
    itemCount: 0,
    editedId: -1,
    editedItem: {
      customerId: "",
      discountRate: 0,
      updatedAt: null,
      updatedBy: null,
    },
    defaultItem: {
      customerId: "",
      discountRate: 0,
      updatedAt: null,
      updatedBy: null,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        customerId: item.customerId,
        discountRate: item.discountRate,
        updatedAt: item.updatedAt,
        updatedBy: item.updatedBy,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setItemCount(state, count) {
      state.itemCount = count;
    },
    setCustomer(state, customerId) {
      state.editedItem.customerId = customerId;
    },
    setDiscountRate(state, discountRate) {
      state.editedItem.discountRate = discountRate;
    },
  },
  actions: {
    fetchCartByCustomer({ commit }, customerId) {
      return cart.getByCustomer(customerId).then((response) => {
        commit("setCustomer", response.data.customerId);
        commit("setDiscountRate", response.data.discountRate);
        commit("setItems", response.data);
        commit("setEditedId", response.data.cartId);
        commit("setItemCount", response.data.cartItems.length);
        return response;
      });
    },
    addItemToCart({ commit }, data) {
      const productToSend = {
        productId: data.productId,
        quantity: data.quantity,
        price: data.price,
        vat: data.vat,
        gimPackContent: data.gimPackContent,
        customer: data.customer,
      };
      return cart.postItemsCart(productToSend).then((response) => {
        commit("setItemCount", response.data.itemCount);
        commit("setItems", response.data);
        return response;
      });
    },
    deleteItem({ commit }, itemId) {
      return cart.deleteItemsCart(itemId).then((response) => {
        commit("setItemCount", response.data.itemCount);
        return response;
      });
    },
    updateItem({ dispatch, state }, item) {
      const productToSend = {
        productId: item.productId,
        cartItemId: item.cartItemId,
        quantity: item.quantity,
        gimPackContent: item.gimPackContent,
        price: item.price,
        vat: item.vat,
      };
      return cart
        .updatedItem(item.cartItemId, productToSend)
        .then((response) => {
          dispatch("fetchCartByCustomer", state.editedItem.customerId);
          return response;
        });
    },
    applyDiscount({ dispatch }, discountData) {
      const data = {
        customerId: discountData.customerId,
        discount: discountData.discount,
      };
      return cart.postDiscountCart(data).then((response) => {
        dispatch("fetchCartByCustomer", discountData.customerId);
        return response;
      });
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
